import { configureStore } from '@reduxjs/toolkit';
import userDataReducer from './features/Slices/userDataSlice';

export default configureStore({
    reducer: {
        userData: userDataReducer
    }
});